import { observable } from "mobx";

export default class VideoModel {
    id = Math.random();
    @observable name = "";    
    @observable url = "";
    @observable enabled = true;
    @observable manageronly = false;
    @observable clusters = [];
    @observable createduserid = null;    
    @observable createddatetime = null;
    @observable releasedate = new Date();  // default release date is today
    @observable expirydate = new Date(new Date().getTime() + 864e5); 

    constructor(id, name, url, clusters, expirydate, releasedate, enabled, manageronly) {
        if (id != null) this.id = id;
        if (name != null) this.name = name;        
        if (url != null) this.url = url;
        if (enabled != null) this.enabled = enabled;
        if (manageronly != null) this.manageronly = manageronly;
        if (clusters != null) this.clusters = clusters;
        if (expirydate != null) this.expirydate = expirydate;
        if (releasedate != null) this.releasedate = releasedate;                    
    }
}


// WEBPACK FOOTER //
// ./src/models/VideoModel.js